export default __webpack_public_path__ + "static/media/hot-gadgets.129dfdf8.PNG";